export default __webpack_public_path__ + "static/media/failureContainerMain.9c4549f0.svg";